import _pickBy from 'lodash/pickBy';
import moment from 'moment-timezone';

export const editPromissorySanitizer = values => {
  const sanitizedFilters = {
    debtor: {
      name: values.debtorName,
      lastName: values.debtorLastName,
      dateOfBirth: moment(values.debtor_date_of_birth, 'YYYY/MM/DD').format(
        'YYYY-MM-DD'
      ),
      phone: values.debtorPhone,
      mobile: values.debtorMobile,
      idExpeditionDate: moment(
        values.debtorExpeditionDate,
        'YYYY/MM/DD'
      ).format('YYYY-MM-DD'),
      idExpeditionPlace: values.debtorExpeditionPlace
    },
    cosigner: values.cosignerName
      ? {
          name: values.cosignerName,
          lastName: values.cosignerLastName,
          dateOfBirth: moment(
            values.cosigner_date_of_birth,
            'YYYY/MM/DD'
          ).format('YYYY-MM-DD'),
          phone: values.cosignerPhone,
          mobile: values.cosignerMobile,
          idExpeditionDate: moment(
            values.cosignerExpeditionDate,
            'YYYY/MM/DD'
          ).format('YYYY-MM-DD'),
          idExpeditionPlace: values.cosignerExpeditionPlace
        }
      : null
  };
  const params = _pickBy(sanitizedFilters, filter => !!filter);
  return {
    ...params
  };
};
